const replacements = new Map([
  [/\b(Eco\s?Vero|Ecovero)(?!™)\b/g, 'EcoVero™'],
  [/\b(Super\s?Merino|super\s?merino)(?!™)\b/g, 'Super Merino™'],
  [/\b(Soft\s?Touch|soft\s?touch)(?!™)\b/g, 'Soft Touch™'],
  [/\bOoohCotton(?!®)\b/g, 'OoohCotton®']
]);

export const replaceWords = (text) => {
  for (const [regex, replacement] of replacements) {
    text = text.replace(regex, replacement);
  }
  return text;
};